import React, { useState } from "react";
import { Button, DialogContent, TextField, Typography } from "@mui/material";
import { StyledDialog } from "../Lease.styled";
import Parse from "../../../api/ApiConfig";
import { createPin } from "../utils";
import { toast } from "react-toastify";

/* eslint-disable react/prop-types */
export const ActivationModal = ({
	modalOpen,
	handleModalClose,
	handleActivateAsset,
	currentStage,
	setCurrentStage,
	setPinModalOpen,
}) => {
	const amount = 100;

	const ConfirmationStage1 = () => {
		return (
			<>
				<div className='dialog_icon mx-auto'>
					<svg width={93} height={93} viewBox='0 0 93 93' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M43.4495 0.98938C45.4706 0.669277 47.5294 0.669277 49.5505 0.98938L57.6624 2.27418C59.6834 2.59428 61.6415 3.2305 63.4647 4.15948L70.7826 7.88811C72.6058 8.81709 74.2714 10.0272 75.7184 11.4742L81.5258 17.2816C82.9728 18.7286 84.1829 20.3942 85.1119 22.2174L88.8405 29.5353C89.7695 31.3585 90.4057 33.3166 90.7258 35.3376L92.0106 43.4495C92.3307 45.4706 92.3307 47.5294 92.0106 49.5505L90.7258 57.6624C90.4057 59.6834 89.7695 61.6415 88.8405 63.4647L85.1119 70.7826C84.1829 72.6058 82.9728 74.2714 81.5258 75.7184L75.7184 81.5258C74.2714 82.9728 72.6058 84.1829 70.7826 85.1119L63.4647 88.8405C61.6415 89.7695 59.6834 90.4057 57.6624 90.7258L49.5505 92.0106C47.5294 92.3307 45.4706 92.3307 43.4495 92.0106L35.3376 90.7258C33.3166 90.4057 31.3585 89.7695 29.5353 88.8405L22.2174 85.1119C20.3942 84.1829 18.7286 82.9728 17.2816 81.5258L11.4742 75.7184C10.0272 74.2714 8.81709 72.6058 7.88811 70.7826L4.15948 63.4647C3.2305 61.6415 2.59428 59.6834 2.27418 57.6624L0.98938 49.5505C0.669277 47.5294 0.669277 45.4706 0.98938 43.4495L2.27418 35.3376C2.59428 33.3166 3.2305 31.3585 4.15948 29.5353L7.88811 22.2174C8.81709 20.3942 10.0272 18.7286 11.4742 17.2816L17.2816 11.4742C18.7286 10.0272 20.3942 8.81709 22.2174 7.88811L29.5353 4.15948C31.3585 3.2305 33.3166 2.59428 35.3376 2.27418L43.4495 0.98938Z'
							fill='#E3E9EC'
							stroke='#AABDC5'
						/>
						<path
							d='M40.9062 43.3438H47.4062V60.8125'
							stroke='#00525D'
							strokeWidth='4.0625'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
						<path
							d='M39.9922 61.2188H54.0078'
							stroke='#00525D'
							strokeWidth='4.0625'
							strokeMiterlimit={10}
							strokeLinecap='round'
						/>
						<path
							d='M47 37.25C46.3572 37.25 45.7289 37.0594 45.1944 36.7023C44.6599 36.3452 44.2434 35.8376 43.9974 35.2437C43.7514 34.6499 43.687 33.9964 43.8124 33.366C43.9379 32.7355 44.2474 32.1564 44.7019 31.7019C45.1564 31.2474 45.7355 30.9379 46.366 30.8124C46.9964 30.687 47.6499 30.7514 48.2437 30.9974C48.8376 31.2434 49.3452 31.6599 49.7023 32.1944C50.0594 32.7289 50.25 33.3572 50.25 34C50.25 34.862 49.9076 35.6886 49.2981 36.2981C48.6886 36.9076 47.862 37.25 47 37.25Z'
							fill='#00525D'
						/>
					</svg>
				</div>

				<DialogContent>
					<p>
						<span className='fw-500'>₦{amount}</span> will be deducted from your wallet for your Credit
						Assessment
					</p>
				</DialogContent>

				<Button variant='contained' className='w-full' onClick={() => setCurrentStage("enterPin2")} autoFocus>
					Proceed
				</Button>
			</>
		);
	};

	const EnterPinStage2 = () => {
		const [pinInput, setPinInput] = useState("");

		const userAccessPin = Parse.User.current().get("accessPin");

		const handlePinValidation = () => {
			if (pinInput.length < 4 || pinInput.length > 4) {
				toast.error("Pin must be 4 digits");
				return;
			} else {
				handleActivateAsset(pinInput);
			}
		};

		return (
			<>
				<Typography variant='h5' mb={1} fontWeight={500}>
					Enter Your Pin
				</Typography>

				<DialogContent className='px-0' sx={{ minWidth: "320px" }}>
					<TextField
						label='PIN'
						fullWidth
						value={pinInput}
						onChange={(e) => setPinInput(e.target.value)}
						inputProps={{ inputMode: "numeric", type: "number" }}
						className='hideNumberArrows'
					/>
				</DialogContent>

				<Button variant='contained' className='w-full' onClick={handlePinValidation}>
					Proceed
				</Button>

				{!userAccessPin && (
					<Button sx={{ mt: 2 }} onClick={() => setPinModalOpen(true)}>
						Create Access Pin
					</Button>
				)}
			</>
		);
	};

	const SuccessfulStage3 = () => {
		return (
			<>
				<div className='dialog_icon mx-auto'>
					<svg width={93} height={93} viewBox='0 0 93 93' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M43.4495 0.98938C45.4706 0.669277 47.5294 0.669277 49.5505 0.98938L57.6624 2.27418C59.6834 2.59428 61.6415 3.2305 63.4647 4.15948L70.7826 7.88811C72.6058 8.81709 74.2714 10.0272 75.7184 11.4742L81.5258 17.2816C82.9728 18.7286 84.1829 20.3942 85.1119 22.2174L88.8405 29.5353C89.7695 31.3585 90.4057 33.3166 90.7258 35.3376L92.0106 43.4495C92.3307 45.4706 92.3307 47.5294 92.0106 49.5505L90.7258 57.6624C90.4057 59.6834 89.7695 61.6415 88.8405 63.4647L85.1119 70.7826C84.1829 72.6058 82.9728 74.2714 81.5258 75.7184L75.7184 81.5258C74.2714 82.9728 72.6058 84.1829 70.7826 85.1119L63.4647 88.8405C61.6415 89.7695 59.6834 90.4057 57.6624 90.7258L49.5505 92.0106C47.5294 92.3307 45.4706 92.3307 43.4495 92.0106L35.3376 90.7258C33.3166 90.4057 31.3585 89.7695 29.5353 88.8405L22.2174 85.1119C20.3942 84.1829 18.7286 82.9728 17.2816 81.5258L11.4742 75.7184C10.0272 74.2714 8.81709 72.6058 7.88811 70.7826L4.15948 63.4647C3.2305 61.6415 2.59428 59.6834 2.27418 57.6624L0.98938 49.5505C0.669277 47.5294 0.669277 45.4706 0.98938 43.4495L2.27418 35.3376C2.59428 33.3166 3.2305 31.3585 4.15948 29.5353L7.88811 22.2174C8.81709 20.3942 10.0272 18.7286 11.4742 17.2816L17.2816 11.4742C18.7286 10.0272 20.3942 8.81709 22.2174 7.88811L29.5353 4.15948C31.3585 3.2305 33.3166 2.59428 35.3376 2.27418L43.4495 0.98938Z'
							fill='#E3E9EC'
							stroke='#AAC5B1'
						/>
						<path
							d='M64.4237 32.9048C64.8226 33.2598 65.0643 33.7586 65.0957 34.2917C65.127 34.8248 64.9455 35.3486 64.5909 35.7479L43.0989 59.9279C42.9099 60.1407 42.6779 60.3109 42.4183 60.4275C42.1587 60.5442 41.8773 60.6044 41.5927 60.6044C41.3081 60.6044 41.0267 60.5442 40.7671 60.4275C40.5075 60.3109 40.2755 60.1407 40.0865 59.9279L29.3405 47.8379C29.0062 47.4359 28.8414 46.9196 28.8807 46.3982C28.9201 45.8768 29.1605 45.3911 29.5513 45.0438C29.9421 44.6964 30.4526 44.5145 30.975 44.5366C31.4974 44.5587 31.9908 44.7829 32.3509 45.162L41.5917 55.5574L61.5805 33.07C61.9358 32.6713 62.4348 32.43 62.9679 32.399C63.501 32.368 64.0246 32.5499 64.4237 32.9048Z'
							fill='#00525D'
						/>
					</svg>
				</div>

				<DialogContent>
					<p>Asset has been Activated Successfully</p>
				</DialogContent>

				<Button variant='contained' className='w-full' onClick={handleModalClose} autoFocus>
					Done
				</Button>
			</>
		);
	};

	return (
		<StyledDialog className='activationModal' open={modalOpen} onClose={handleModalClose} maxWidth='xs'>
			{currentStage == "enterPin2" && <EnterPinStage2 />}
			{currentStage == "confirm1" && <ConfirmationStage1 />}
			{currentStage == "successful" && <SuccessfulStage3 />}
		</StyledDialog>
	);
};

export const CreatePinModal = ({ modalOpen, setPinModalOpen }) => {
	const [pinInput1, setPinInput1] = useState("");
	const [pinInput2, setPinInput2] = useState("");

	const handleModalClose = () => {
		setPinModalOpen(false);
	};

	const handleCreatePin = async () => {
		if (pinInput1.length !== 4) {
			toast.error("Pin must be 4 digits");
			return;
		} else if (pinInput1 !== pinInput2) {
			toast.error("Pins do not match");
			return;
		} else if (pinInput1 === pinInput2) {
			// Create access pin
			const res = await createPin(pinInput1);
			if (!res.error) {
				toast.success("Pin created successfully");
				setPinModalOpen(false);
			} else {
				toast.error(res.error || "Error creating pin");
			}
		}
	};

	return (
		<StyledDialog className='activationModal' open={modalOpen} onClose={handleModalClose} maxWidth='xs'>
			<Typography variant='h5' mb={2} fontWeight={500}>
				Create New Pin
			</Typography>

			<DialogContent className='px-0' sx={{ minWidth: "320px" }}>
				<TextField
					label='New PIN'
					fullWidth
					inputProps={{ inputMode: "numeric", type: "number" }}
					value={pinInput1}
					onChange={(e) => setPinInput1(e.target.value)}
					className='hideNumberArrows'
					id='pinInput1'
				/>

				<TextField
					label='Confirm PIN'
					fullWidth
					inputProps={{ inputMode: "numeric", type: "number" }}
					value={pinInput2}
					onChange={(e) => setPinInput2(e.target.value)}
					className='hideNumberArrows'
					sx={{ mt: 2.5 }}
					id='pinInput2'
				/>
			</DialogContent>

			<Button variant='contained' className='w-full' onClick={handleCreatePin}>
				Create Pin
			</Button>
		</StyledDialog>
	);
};
